import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule
  ],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  features = [
    {
      title: 'Brand Analysis',
      description: 'Comprehensive brand analysis across AI platforms including sentiment analysis, content distribution, and consumer preferences.',
      icon: 'analytics',
      route: '/brand-analysis',
      color: '#1976d2',
      features: [
        'AI Brand Index scoring',
        'Sentiment analysis',
        'Content distribution insights',
        'Consumer preferences analysis',
        'Brand visibility tracking'
      ]
    },
    {
      title: 'University Analysis',
      description: 'Advanced university comparison and analysis tools for educational institutions and prospective students.',
      icon: 'school',
      route: '/v4/education?role=university&plan=paid&course=MBA&country=UK&pin=8898',
      color: '#388e3c',
      features: [
        'University comparison',
        'Course analysis',
        'Country-wise rankings',
        'Performance metrics',
        'Student satisfaction data'
      ]
    },
    {
      title: 'Discover AI Courses',
      description: 'Your one-stop platform to explore, compare, and choose the best Artificial Intelligence courses from top universities worldwide.',
      icon: 'search',
      route: '/ai-course-finder',
      color: '#ff9800',
      features: [
        'Smart course search',
        'University comparison',
        'Personalized recommendations',
        'Career outcomes data',
        'Student satisfaction ratings'
      ]
    }
    // University AI Index feature is commented out as per user's changes
  ];

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit() {
    // Check if user is already authenticated
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
    }
  }

  selectIndustry(industry: string) {
    // Navigate directly to the Brand Analysis page
    this.snackBar.open(`Navigating to Brand Analysis with ${industry} industry selected...`, 'Close', {
      duration: 2000,
    });

    // Navigate to the brand-analysis page with the selected industry
    this.router.navigate(['/brand-analysis'], {
      queryParams: {
        industry: industry,
        source: 'landing'
      }
    });
  }
}
